<section class="not-found">
    <p class="not-found__code">404</p>
    <h1 class="not-found__title">{{ 'core.notFound.title' | translate }}</h1>
    <p class="not-found__text">{{ 'core.notFound.text' | translate }}</p>
    <a class="not-found__home" mat-button [routerLink]="homeLink()">
        {{ 'core.notFound.home' | translate }}
    </a>
</section>
